import React from 'react';
import { LegalLayout } from '../components/LegalLayout';

const isSolo = process.env.REACT_APP_SOLO_LANDING === 'true';
const linkCl = isSolo ? 'text-purple-600 hover:text-purple-700 dark:text-purple-400 dark:hover:text-purple-300 underline' : 'text-indigo-600 hover:text-indigo-800 underline';

const CookiesPolicy = () => (
  <LegalLayout>
    <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-2">Cookie policy</h1>
    <p className="text-lg text-gray-600 dark:text-gray-300 mb-8">
      Last updated: January 2026. {process.env.REACT_APP_SOLO_LANDING === 'true' ? 'SEN-Education' : 'SEN-Ed'} is a product of The Send Tech Company Ltd (SEN-Ed is a trading name). Company number 16756429. Registered office: 167-169 Great Portland Street, London, England, W1W 5PF.
    </p>

    <h2 className="text-2xl font-bold text-gray-900 dark:text-white mt-10 mb-4">What are cookies?</h2>
    <p className="text-gray-700 dark:text-gray-300">
      Cookies are small text files stored on your device when you visit a website. They help the site work, remember preferences, and (where used) understand how the site is used.
    </p>

    <h2 className="text-2xl font-bold text-gray-900 dark:text-white mt-10 mb-4">How we use cookies</h2>
    <p className="text-gray-700 dark:text-gray-300">We use cookies only where necessary:</p>
    <ul className="text-gray-700 dark:text-gray-300 list-disc pl-6 my-4 space-y-2">
      <li><strong>Essential cookies</strong> – Required for the site and the application to work (e.g. session, security). You cannot turn these off while using the service.</li>
      <li><strong>Optional cookies</strong> – If we use analytics or similar tools, we will describe them here and you can control them via your browser settings.</li>
    </ul>
    <p className="text-gray-700 dark:text-gray-300">
      We do not use cookies for advertising or to track you across other websites.
    </p>

    <h2 className="text-2xl font-bold text-gray-900 dark:text-white mt-10 mb-4">Your choices</h2>
    <p className="text-gray-700 dark:text-gray-300">
      By using this site you accept our use of essential cookies. For optional cookies, you can use your browser settings to block or delete cookies. Blocking essential cookies may prevent the site or application from working properly.
    </p>
    <p className="text-gray-700 dark:text-gray-300">
      Contact us at <a href="mailto:contact@sen-ed.co.uk" className={linkCl}>contact@sen-ed.co.uk</a> if you have questions about our use of cookies.
    </p>

    <h2 className="text-2xl font-bold text-gray-900 dark:text-white mt-10 mb-4">Changes</h2>
    <p className="text-gray-700 dark:text-gray-300">
      We may update this cookie policy from time to time. The &quot;Last updated&quot; date will change when we do. Continued use of the site after changes indicates acceptance of the updated policy.
    </p>

    <h2 className="text-2xl font-bold text-gray-900 dark:text-white mt-10 mb-4">Contact</h2>
    <p className="text-gray-700 dark:text-gray-300">
      For questions about cookies or this policy: <a href="mailto:contact@sen-ed.co.uk" className={linkCl}>contact@sen-ed.co.uk</a>. The Send Tech Company Ltd, 167-169 Great Portland Street, London, England, W1W 5PF.
    </p>
  </LegalLayout>
);

export default CookiesPolicy;
